import { render, staticRenderFns } from "./ITextarea.vue?vue&type=template&id=8761141c"
import script from "./ITextarea.vue?vue&type=script&lang=js"
export * from "./ITextarea.vue?vue&type=script&lang=js"
import style0 from "./ITextarea.vue?vue&type=style&index=0&id=8761141c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports